/* tslint:disable */
import { types, flow } from 'mobx-state-tree'
import { apolloClient } from '../utils/apolloClient';
import { ME_QUERY } from '../queries/ME_QUERY';

const MenuStore = types.model({
  userType: types.maybeNull(types.string),
  isMenuShown: false,
  path: '',
  hostname: '',
})
  .actions(self => ({
    afterCreate: flow(function* fetch() {
      try {
        const { data: { me } } = yield apolloClient.query({ query: ME_QUERY })
        if (me) {
          self.userType = me.userType
        }
      } catch (error) {
        console.error('Failed to fetch', error) // tslint:disable-line:no-console
      }
    }),

    goLink (history, link) {
      history.push(link)

      console.log('pathname', window.location.pathname)
      self.path = window.location.pathname
      self.hostname = window.location.hostname
      self.isMenuShown = false
    },
    updatePath () {
      self.path = window.location.pathname
      self.hostname = window.location.hostname
    },
    showMenu () {
      self.isMenuShown = true
    },
    hideMenu () {
      self.isMenuShown = false
    }

  }))
  .views(self => ({
    get isWelcomeSelected () {
      return self.path.includes('welcome') && !self.path.includes('welcome-back')
    },
    get isKidsSelected () {
      return self.path.includes('kids')
    },
    get isWebTipsSelected () {
      return !self.isKidsSelected
    },
    get isWebInfo () {
      if (self.userType && self.userType.includes('PARENT_WEBINFO')) {
        return true;
      }
      if (self.hostname.includes('webinfo')) {
        return true
      }
      let res = self.path.includes('contents')
      if (!res) return false
      const contentName = self.path.split('contents/')[1]

      if (contentName.includes('webinfo')) {
        return true
      }
      return false
    },
    get isInfoSelected () {
      if (self.path.includes('intake') || self.path.includes('review')) {
        return true
      }

      let res = self.path.includes('contents')

      if (!res) return
      const contentName = self.path.split('contents/')[1]

      if (contentName.includes('webinfo')) {
        return true
      }

      let num = parseInt(contentName, 10)
      return res && num >= 0 && num <= 1000 && num !== 63
    },
    get pageNumber () {
      if (!self.path.includes('contents/')) {
        return -1
      }

      if (self.isWebInfo) {
        return parseInt(self.path.split('webinfo-')[1], 10)
      }

      return parseInt(self.path.split('contents/')[1], 10)
    },
    get isInfoSection1Selected () {
      if (self.isWebInfo) {
        return self.pageNumber >= 1 &&
        self.pageNumber <= 5
      }
      return self.pageNumber >= 1 &&
        self.pageNumber <= 18
    },
    get isInfoSection2Selected () {
      if (self.isWebInfo) {
        return self.pageNumber >= 6 &&
        self.pageNumber <= 11
      }
      return self.pageNumber >= 19 &&
        self.pageNumber <= 29
    },
    get isInfoSection3Selected () {
      if (self.isWebInfo) {
        return self.pageNumber >= 12 &&
        self.pageNumber <= 17
      }
      return self.pageNumber >= 30 &&
        self.pageNumber <= 37
    },
    get isInfoSection4Selected () {
      if (self.isWebInfo) {
        return self.pageNumber >= 18
      }
      return self.pageNumber >= 38 && self.pageNumber < 63
    },
    get isHelpSelected () {
      return self.path.includes('help') ||
        self.path.includes('webtips-faq') || self.path.includes('surgery-faq')
    },
    get linkSection1 () {
      if (self.isWebInfo) {
        return '/contents/webinfo-01'
      }
      return '/contents/01'
    },
    get linkSection2 () {
      if (self.isWebInfo) {
        return '/contents/webinfo-06'
      }
      return '/contents/19'
    },
    get linkSection3 () {
      if (self.isWebInfo) {
        return '/contents/webinfo-12'
      }
      return '/contents/30'
    },
    get linkSection4 () {
      if (self.isWebInfo) {
        return '/contents/webinfo-18'
      }
      return '/contents/38'
    },
    get isPrintSelected () {
      return self.pageNumber === 63
    },
    get isAboutSelected () {
      return self.path.includes('why-it-works') ||
      self.path.includes('why-it-works-2') ||
      self.path.includes('who-we-are')
    },
    get isKidsVideoSelected () {
      return self.path.includes('kids-video')
    },
    get isKidsTourSelected () {
      return self.path.includes('kids-tour')
    },
    get isKidsGamesSelected () {
      return self.path.includes('game')
    },
    get isKidsActivitiesSelected () {
      return self.path.includes('kids-activities')
    }

  }))
  .preProcessSnapshot(snapshot => {
    let path = window.location.pathname
    let hostname = window.location.hostname
    return {
      path,
      hostname,
      ...snapshot
    }
  })

export default MenuStore



// WEBPACK FOOTER //
// ./src/stores/MenuStore.js